import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=3e852604&scoped=true&"
import script from "./GlobalSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalSettings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=3e852604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e852604",
  null
  
)

export default component.exports